<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row">
      <div class="col-md-12">
        <!-- <appQuantitySelectionContainer></appQuantitySelectionContainer>             -->
        <appOptionsTable>
          <appOptionsContainer></appOptionsContainer>
          <appInputCustomFormatInsert></appInputCustomFormatInsert>
        </appOptionsTable>
        <appQuantityTable>
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appAddToCartButton></appAddToCartButton>
        <appQuotationButton></appQuotationButton>
        <appOtherOptionsTable>
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

export default {};
</script>
